import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Popover, OverlayTrigger, FormControl } from 'react-bootstrap';
import CyberSecurity from '../../../../../../apis/cyberSecurityData';
import { updateProfile } from '../../../../../../actions/userActions';
//imported comps
import ColorPicker from './ColorPicker';

const AddLabel = ({ label, trigger }) => {
    //redux store state
    const accessToken = useSelector(state => state.accessToken);
    const personalTags = useSelector(state => state.currentUser.personalTags);
    const dispatch = useDispatch();
    //comp state
    const [labelName, setLabelName] = useState(label ? label.label : '')
    const [labelColor, setLabelColor] = useState(label ? label.color : '#BABABA')
    const [error, setError] = useState('');

    const updateUserPersonalTags = async (newList) => {
        const response = await CyberSecurity.post('/users/labels', { labels: newList }, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.data.error) dispatch(updateProfile(response.data))
    }

    useEffect(() => {
        if (label) setLabelName(label.label)
        if (label) setLabelColor(label.color)
    }, [personalTags])

    const onAddClick = async () => {
        console.log(labelColor)
        //set an error (add or edit) if no name or no color
        if (!labelName) return setError('Please enter label name');
        if (!labelColor) return setError('Please enter label color');

        if (label) {
            //code here will run if in edit label mode
            //1. need to check if the name is now matching any other exisiting label
            const restLabels = personalTags.filter(el => el._id !== label._id);
            if (restLabels.length > 0) {
                const existLabel = restLabels.filter(el => el.label.toLowerCase() === labelName.toLowerCase())[0];
                if (existLabel) return setError('There is a label with the same name');
            }

            if (error) setError('');

            //create a new list to be added
            const newLabel = { ...label, label: labelName, color: labelColor };
            const newList = personalTags.map(el => el._id === label._id ? newLabel : el);
            updateUserPersonalTags(newList);

        } else {
            //code here will run if in adding new label mode
            //1. need to check if the name is exisit
            if (personalTags) {
                const existLabel = personalTags.filter(label => label.label.toLowerCase() === labelName.toLowerCase())[0];
                if (existLabel) return setError('There is a label with the same name')
            }

            if (error) setError('');
            const newLabel = {
                label: labelName,
                color: labelColor
            }
            let newList = [];
            if (personalTags) newList = [...personalTags, newLabel];
            else newList.push(newLabel);
            updateUserPersonalTags(newList);
            //reseting the fields and closing the adding popup
            setLabelName('');
            setLabelColor('');
        }

        document.body.click()
    }

    const onDeleteClick = async (labelId) => {
        const response = await CyberSecurity.delete(`/users/labels/${labelId}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        dispatch(updateProfile(response.data))
        document.body.click()
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3" className="d-flex align-content-canter">
                <span>{label ? 'Edit Personal Tag' : 'Add personal Tag'}</span>
                <span className="material-icons pointer text-light-grey text-sm ml-auto" onClick={() => document.body.click()}>close</span>
            </Popover.Title>
            <Popover.Content>
                <div className="d-flex align-items-center">
                    {/* <FormControl className="mr-2" value={labelName} placeholder="Label Name" onChange={(e) => setLabelName(e.target.value)} onKeyPress={(e) => { if (e.Key === 'Enter') onAddClick() }} /> */}
                    <FormControl className="mr-2" value={labelName} placeholder="Tag Name" onChange={(e) => setLabelName(e.target.value)} onKeyPress={(e) => { if (e.key === 'Enter') onAddClick() }} />
                    <ColorPicker labelColor={labelColor} setLabelColor={setLabelColor} label={label} />
                </div>
                {error && <p className="text-red">{error}</p>}
                {/* <SketchPicker
                    className="mt-3"
                    color={labelColor}
                    onChange={(color) => setLabelColor(color.hex)}
                /> */}
                <Button className="mt-3 mr-2" variant="primary" onClick={onAddClick}>{label ? 'Save' : 'Add'}</Button>
                {label && <Button className="mt-3" variant="secondary" onClick={() => onDeleteClick(label._id)}>Delete</Button>}
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose={true}>
            {trigger}
        </OverlayTrigger>
    )
}

export default AddLabel
